import React from "react";
import "./style.scss";

const AnnouncementHeader = (props) => {
  return (
    <div
      className={`base-header-announcement`}
      style={
        props.isCustomPicture
          ? { backgroundImage: props.picture }
          : { backgroundColor: "#FF5829" }
      }
      onClick={props.onClickImageHeader}
    >
      <div className="header-announcement-button">
        <a href="">
          <img src={props.src} alt="logo_image" onClick={props.onClick} />
        </a>
      </div>
      <div className="header-announcement-text">
        <span className="text-title">{props.title}</span>
      </div>
    </div>
  );
};

export default AnnouncementHeader;
